import type { ReactNode } from "react";

export function ProcessTimeline({ children, up = false }: { children: ReactNode; up?: boolean }) {
  return (
    <ol className="relative ml-[5px] border-l border-ink/15 pl-6">
      <span aria-hidden="true" className={`absolute -left-[4px] h-0 w-0 border-l-4 border-r-4 border-l-transparent border-r-transparent ${
        up ? "-top-[7px] border-b-[7px] border-b-ink/15" : "-bottom-[7px] border-t-[7px] border-t-ink/15"
      }`} />
      {children}
    </ol>
  );
}
